import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';

import type { OptionalAppRoute } from '../types';

/**
 * Whether the parameters found in the URL agree with the parameters the route declares.
 *
 * A route declares parameters to tell one family of pages from another, so a route that declares
 * parameters never matches a URL that carries none.
 */
export const doParamsAgree = (route?: OptionalAppRoute<any>, matchedParams?: Record<string, any>): boolean => {
    if (!route?.params) {
        return true;
    }

    const onlyMatchedParams = pick(matchedParams, Object.keys(route.params));
    const onlyMatchedParamsKeys = Object.keys(onlyMatchedParams);

    if (onlyMatchedParamsKeys.length === 0) {
        return false;
    }

    return isEqual(onlyMatchedParams, pick(route.params, onlyMatchedParamsKeys));
};
